const nissePranks = [

  {

    title: "Nissen har ritat på frukten",

    description: "Rita små ansikten, tomteluvor eller roliga miner på bananer, clementiner eller äpplen.",

    age: "1-3",

    place: "kök",

    prep: "ingen",

    props: "nej"

  },
  {

    title: "Nissen har ritat på frukten",

    description: "Rita små ansikten, tomteluvor eller roliga miner på bananer, clementiner eller äpplen.",

    age: "4-7",

    place: "kök",

    prep: "ingen",

    props: "nej"

  },

  {

    title: "Magisk mjölk",

    description: "Droppa lite karamellfärg i mjölken eller yoghurten så att frukosten får en magisk färg.",

    age: "1-3",

    place: "kök",

    prep: "lite",

    props: "ja"

  },
{

    title: "Magisk mjölk",

    description: "Droppa lite karamellfärg i mjölken eller yoghurten så att frukosten får en magisk färg.",

    age: "4-7",

    place: "kök",

    prep: "lite",

    props: "ja"

  },
  {

    title: "Chokladmjölk till frukost",

    description: "Byt ut vanlig mjölk mot chokladmjölk och låt Nisse ta på sig skulden.",

    age: "4-7",

    place: "kök",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Rörliga ögon i kylskåpet",

    description: "Sätt rörliga ögon på mjölkpaket, yoghurt, frukt eller andra saker i kylskåpet.",

    age: "4-7",

    place: "kök",

    prep: "lagom",

    props: "ja"

  },
    {

    title: "Rörliga ögon i kylskåpet",

    description: "Sätt rörliga ögon på mjölkpaket, yoghurt, frukt eller andra saker i kylskåpet.",

    age: "1-3",

    place: "kök",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Nissens mjölspår",

    description: "Strö lite mjöl eller florsocker på köksbänken och gör små nissespår med fingret.",

    age: "1-3",

    place: "kök",

    prep: "lagom",

    props: "ja"

  },
  {

    title: "Nissens mjölspår",

    description: "Strö lite mjöl eller florsocker på köksbänken och gör små nissespår med fingret.",

    age: "4-7",

    place: "kök",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Snöängel i mjöl",

    description: "Strö ut lite mjöl på bänken och gör en liten snöängel med fingrarna.",

    age: "1-3",

    place: "kök",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Dags att baka lussebullar",

    description: "Ställ fram en korg med ingredienser till lussebullar eller annat julbak.",

    age: "4-7",

    place: "kök",

    prep: "mycket",

    props: "ja"

  },
  {

    title: "Dags att baka lussebullar",

    description: "Ställ fram en korg med ingredienser till lussebullar eller annat julbak.",

    age: "8+",

    place: "kök",

    prep: "mycket",

    props: "ja"

  },

  {

    title: "Chokladägg i äggkartongen",

    description: "Byt ut några ägg i äggkartongen mot chokladägg.",

    age: "4-7",

    place: "kök",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Fryst frukost",

    description: "Lägg fram något oväntat till frukost som du fryst in kvällen innan, till exempel blöta underkläder/ blöja.",

    age: "1-3",

    place: "kök",

    prep: "lite",

    props: "nej"

  },
 {

    title: "Fryst frukost",

    description: "Lägg fram något oväntat till frukost som du fryst in kvällen innan, till exempel blöta underkläder.",

    age: "4-7",

    place: "kök",

    prep: "lite",

    props: "nej"

  },
   {

    title: "Fryst frukost",

    description: "Lägg fram något oväntat till frukost som du fryst in kvällen innan, till exempel blöta underkläder.",

    age: "8+",

    place: "kök",

    prep: "lite",

    props: "nej"

  },
      {

    title: "Tokig frukost",

    description: "Lägg fram något oväntat till frukost, till exempel godis eller en rolig fruktfigur.",

    age: "1-3",

    place: "kök",

    prep: "lite",

    props: "nej"

  },
     {

    title: "Tokig frukost",

    description: "Lägg fram något oväntat till frukost, till exempel godis eller en rolig fruktfigur.",

    age: "4-7",

    place: "kök",

    prep: "lite",

    props: "nej"

  },
   {

    title: "Tokig frukost",

    description: "Lägg fram något oväntat till frukost, till exempel godis eller en rolig fruktfigur.",

    age: "8+",

    place: "kök",

    prep: "lite",

    props: "nej"

  },
    {

    title: "Mjölkpaketet har blivit en ren",

    description: "Rita eller tejpa fast ögon, horn och nos på mjölkpaketet.",

    age: "1-3",

    place: "kök",

    prep: "lagom",

    props: "ja"

  },
  {

    title: "Mjölkpaketet har blivit en ren",

    description: "Rita eller tejpa fast ögon, horn och nos på mjölkpaketet.",

    age: "4-7",

    place: "kök",

    prep: "lagom",

    props: "ja"

  },
{

    title: "Glittrig vattenkran",

    description: "Dekorera vattenkranen försiktigt med glitter, lametta eller ett litet julband.",

    age: "1-3",

    place: "badrum",

    prep: "lite",

    props: "ja"

  },
  {

    title: "Glittrig vattenkran",

    description: "Dekorera vattenkranen försiktigt med glitter, lametta eller ett litet julband.",

    age: "4-7",

    place: "badrum",

    prep: "lite",

    props: "ja"

  },
  {

    title: "Ballonger i badrummet",

    description: "Fyll handfatet, duschen eller badkaret med några ballonger.",

    age: "1-3",

    place: "badrum",

    prep: "lagom",

    props: "ja"

  },
  {

    title: "Ballonger i badrummet",

    description: "Fyll handfatet, duschen eller badkaret med några ballonger.",

    age: "4-7",

    place: "badrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Nissen badar i marshmallows",

    description: "Lägg Nisse i handfatet tillsammans med marshmallows eller bomullstussar.",

    age: "4-7",

    place: "badrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Toaletten blev en snögubbe",

    description: "Klipp ut ögon, knappar och en orange näsa i papper och fäst på toaletten.",

    age: "1-3",

    place: "badrum",

    prep: "mycket",

    props: "ja"

  },

  {

    title: "Toaletten blev en ren",

    description: "Dekorera toalocket med renhorn, ögon och en röd mule av papper.",

    age: "4-7",

    place: "badrum",

    prep: "mycket",

    props: "ja"

  },

  {

    title: "Skumtomtar på tandborsten",

    description: "Sätt en liten skumtomte eller godisbit bredvid tandborsten.",

    age: "1-3",

    place: "badrum",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Toapapper med figurer",

    description: "Rita små hjärtan, tomtar eller snögubbar på toapappret.",

    age: "4-7",

    place: "badrum",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Toapapper i dörröppningen",

    description: "Häng upp lite toapapper i dörröppningen till badrummet.",

    age: "4-7",

    place: "badrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Tandborstarna har flyttat",

    description: "Lägg tandborstarna på en oväntad plats i badrummet.",

    age: "1-3",

    place: "badrum",

    prep: "ingen",

    props: "nej"

  },

  {

    title: "Meddelande på spegeln",

    description: "Skriv en liten hälsning från Nisse på spegeln med whiteboardpenna.",

    age: "8+",

    place: "badrum",

    prep: "lagom",

    props: "ja"

  },
  {

    title: "Gosedjuren går luciatåg",

    description: "Ställ gosedjur eller dockor på rad och ge dem glitter, band eller små pappersljus.",

    age: "1-3",

    place: "vardagsrum",

    prep: "lite",

    props: "ja"

  },
  {

    title: "Gosedjuren går luciatåg",

    description: "Ställ gosedjur eller dockor på rad och ge dem glitter, band eller små pappersljus.",

    age: "4-7",

    place: "vardagsrum",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Pappersmuggsjakten",

    description: "Ställ ut några pappersmuggar. Under en av dem gömmer sig en liten överraskning.",

    age: "4-7",

    place: "vardagsrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Nissens laserbana",

    description: "Gör en hinderbana av garn mellan möblerna.",

    age: "8+",

    place: "vardagsrum",

    prep: "mycket",

    props: "ja"

  },

  {

    title: "Fjärrkontrollen har gömt sig",

    description: "Lägg fjärrkontrollen på en rolig eller oväntad plats i vardagsrummet.",

    age: "4-7",

    place: "vardagsrum",

    prep: "ingen",

    props: "nej"

  },

  {

    title: "Juldisco",

    description: "Lämna en lapp där Nisse ber barnen sätta på musik och dansa i tre minuter.",

    age: "4-7",

    place: "vardagsrum",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Nissen har tejpat fast leksaker",

    description: "Tejpa försiktigt fast några små leksaker på väggen eller ett bord som en tokig utställning.",

    age: "4-7",

    place: "vardagsrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Önskelista till Tomten",

    description: "Lägg fram papper och pennor så att barnen kan skriva eller rita sin önskelista.",

    age: "4-7",

    place: "vardagsrum",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Nissen har byggt torn",

    description: "Bygg ett litet torn av klossar, böcker eller kuddar i vardagsrummet.",

    age: "1-3",

    place: "vardagsrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Kläderna har bytt plats",

    description: "Lägg fram en tokig outfit eller blanda några plagg på sängen.",

    age: "4-7",

    place: "sovrum",

    prep: "ingen",

    props: "nej"

  },

  {

    title: "Glitter i godnattboken",

    description: "Lägg lite glitter, lametta eller en liten lapp i barnets godnattbok.",

    age: "1-3",

    place: "sovrum",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Gömda strumpor",

    description: "Göm barnets strumpor och lämna en enkel ledtråd.",

    age: "1-3",

    place: "sovrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Pyjamasbus",

    description: "Knyt pyjamasens ärmar i en lös knut eller lägg pyjamasen på en rolig plats.",

    age: "4-7",

    place: "sovrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Kläder på garderoben",

    description: "Tejpa försiktigt upp några kläder på garderoben eller dörren.",

    age: "4-7",

    place: "sovrum",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Nissen har lämnat en komplimang",

    description: "Lägg en liten lapp från Nisse med en komplimang till barnet.",

    age: "1-3",

    place: "sovrum",

    prep: "lite",

    props: "ja"

  },
    {

    title: "Nissen har lämnat en komplimang",

    description: "Lägg en liten lapp från Nisse med en komplimang till barnet.",

    age: "4-7",

    place: "sovrum",

    prep: "lite",

    props: "ja"

  },
    {

    title: "Nissen har lämnat en komplimang",

    description: "Lägg en liten lapp från Nisse med en komplimang till barnet.",

    age: "8+",

    place: "sovrum",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Skorna står på led",

    description: "Ställ alla skor på ett långt led genom hallen.",

    age: "4-7",

    place: "hall",

    prep: "ingen",

    props: "nej"

  },

  {

    title: "Överraskning i skon",

    description: "Lägg en clementin, liten lapp eller något annat mysigt i barnets sko.",

    age: "1-3",

    place: "hall",

    prep: "lite",

    props: "ja"

  },
  {

    title: "Överraskning i skon",

    description: "Fyll barnets skor med mackaroner eller annan pasta som passar.",

    age: "4-7",

    place: "hall",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Omatchade skor",

    description: "Blanda ihop skorna så att alla par är omaka.",

    age: "4-7",

    place: "hall",

    prep: "lagom",

    props: "nej"

  },

  {

    title: "Inslagna skor",

    description: "Slå in skorna i presentpapper, plastfolie eller något annat du har hemma.",

    age: "4-7",

    place: "hall",

    prep: "mycket",

    props: "ja"

  },

  {

    title: "Skotornet",

    description: "Stapla några skor i hallen till ett litet torn eller konstverk.",

    age: "4-7",

    place: "hall",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Laserbana i hallen",

    description: "Sätt upp garn eller snöre mellan väggar och möbler så att barnen får krypa igenom.",

    age: "8+",

    place: "hall",

    prep: "mycket",

    props: "ja"

  },

  {

    title: "Nissen har gömt favoritskorna",

    description: "Göm barnets skor på en enkel plats och lämna en liten ledtråd.",

    age: "4-7",

    place: "hall",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Nissen har pyntat om granen",

    description: "Flytta några julgranskulor eller häng något litet oväntat i granen.",

    age: "1-3",

    place: "julgranen",

    prep: "ingen",

    props: "nej"

  },

  {

    title: "Strumpor i granen",

    description: "Häng ett par av familjens strumpor i julgranen.",

    age: "4-7",

    place: "julgranen",

    prep: "lite",

    props: "ja"
  },
    {

    title: "Kalsonger, trosor eller bh i granen",

    description: "Häng ett par av någon av föräldrarnas underkläder (kalsonger, trosor eller bh) i julgranen.",

    age: "1-3",

    place: "julgranen",

    prep: "lite",

    props: "ja"

  },
      {

    title: "Blöja i granen",

    description: "Om det finns ett blöjbarn i familjen: Placera en blöja på toppen av julgranen.",

    age: "1-3",

    place: "julgranen",

    prep: "lite",

    props: "ja"

  },
    {

    title: "Kalsonger, trosor eller bh i granen",

    description: "Häng ett par av någon av föräldrarnas underkläder (kalsonger, trosor eller bh) i julgranen.",

    age: "4-7",

    place: "julgranen",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Toapapper runt granen",

    description: "Linda lite toapapper runt granen som om Nisse försökt pynta på sitt eget sätt.",

    age: "4-7",

    place: "julgranen",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Dags att klä granen",

    description: "Lägg fram julpyntet vid granen och låt Nisse be barnen hjälpa till.",

    age: "1-3",

    place: "julgranen",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Granen har fått kläder",

    description: "Pynta granen med barnens strumpor, vantar eller små kläder.",

    age: "4-7",

    place: "julgranen",

    prep: "mycket",

    props: "ja"

  },

  {

    title: "Godis i granen",

    description: "Häng några skumtomtar, polkagrisar eller små godisbitar i granen.",

    age: "4-7",

    place: "julgranen",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Nissen har lämnat spår",

    description: "Gör små spår i snö, jord eller på trappan om vädret passar.",

    age: "1-3",

    place: "utomhus",

    prep: "ingen",

    props: "nej"

  },

  {

    title: "Nissens lilla skatt",

    description: "Göm en liten lapp eller överraskning vid dörren, brevlådan eller på altanen.",

    age: "4-7",

    place: "utomhus",

    prep: "lite",

    props: "ja"

  },

  {

    title: "Upp och ner-snögubbe",

    description: "Bygg en liten snögubbe som står upp och ner om det finns snö ute.",

    age: "4-7",

    place: "utomhus",

    prep: "lagom",

    props: "ja"

  },

  {

    title: "Såpbubblor som snöflingor",

    description: "Lämna såpbubblor och låt barnen blåsa sina egna snöflingor ute.",

    age: "1-3",

    place: "utomhus",

    prep: "lagom",

    props: "ja"

  },
  {

  title: "Nissen har byggt en koja",

  description: "Bygg en liten koja av filtar och kuddar i vardagsrummet.",

  age: "1-3",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},

{

  title: "Banankalas i köket",

  description: "Lägg bananer runt ett tänt värmeljus som om frukten har festat inatt.",

  age: "4-7",

  place: "kök",

  prep: "lite",

  props: "ja"

},

{

  title: "Nissen har lånat strumpor",

  description: "Häng strumpor på lampor, stolar eller dörrhandtag.",

  age: "1-3",

  place: "sovrum",

  prep: "ingen",

  props: "nej"

},

{

  title: "Pepparkaksrånaren",

  description: "Lämna några smulor och en halv pepparkaka bredvid Nissen.",

  age: "1-3",

  place: "kök",

  prep: "lite",

  props: "ja"

},

{

  title: "Nissen har gjort snöstorm",

  description: "Lägg ut bomullstussar eller mini-marshmallows runt granen som snö.",

  age: "1-3",

  place: "julgranen",

  prep: "lagom",

  props: "ja"

},

{

  title: "Kuddbus",

  description: "Bygg ett litet berg av alla soffkuddar mitt i vardagsrummet.",

  age: "4-7",

  place: "vardagsrum",

  prep: "ingen",

  props: "nej"

},

{

  title: "Nissen har låst kylskåpet",

  description: "Sätt ett julband eller garn runt kylskåpshandtaget.",

  age: "4-7",

  place: "kök",

  prep: "lite",

  props: "ja"

},

{

  title: "Tofflor på vift",

  description: "Placera familjens tofflor på helt fel platser i huset.",

  age: "1-3",

  place: "hall",

  prep: "ingen",

  props: "nej"

},

{

  title: "Nissen har pyntat spegeln",

  description: "Sätt fast små pappersstjärnor eller hjärtan runt badrumsspegeln.",

  age: "4-7",

  place: "badrum",

  prep: "lagom",

  props: "ja"

},

{

  title: "Skedarna har fått ben",

  description: "Ställ bestick på rad som om de försöker smita från köket.",

  age: "4-7",

  place: "kök",

  prep: "lite",

  props: "ja"

},

{

  title: "Nissen har gjort snögubbar",

  description: "Rita små snögubbar på clementiner med penna.",

  age: "1-3",

  place: "kök",

  prep: "ingen",

  props: "nej"

},

{

  title: "Julgranen blinkar konstigt",

  description: "Flytta runt några julkulor så att alla röda sitter tillsammans.",

  age: "4-7",

  place: "julgranen",

  prep: "lite",

  props: "nej"

},

{

  title: "Nissen har byggt skobuss",

  description: "Ställ skorna på rad som om de åker tåg genom hallen.",

  age: "1-3",

  place: "hall",

  prep: "ingen",

  props: "nej"

},

{

  title: "Kylskåpsdisco",

  description: "Sätt små papperslappar med dansande figurer i kylskåpet.",

  age: "4-7",

  place: "kök",

  prep: "lagom",

  props: "ja"

},

{

  title: "Nissen har hängt tvätt",

  description: "Häng upp små dockkläder eller strumpor på ett snöre.",

  age: "1-3",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},

{

  title: "Julklapp till tandborsten",

  description: "Slå in tandborsten i lite julpapper eller servett.",

  age: "4-7",

  place: "badrum",

  prep: "lite",

  props: "ja"

},

{

  title: "Nissen har möblerat om",

  description: "Flytta några små saker i vardagsrummet till tokiga platser.",

  age: "4-7",

  place: "vardagsrum",

  prep: "ingen",

  props: "nej"

},

{

  title: "Snögubbar på fönstret",

  description: "Rita små snögubbar på fönstret med fönsterpenna.",

  age: "4-7",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},
{

  title: "Snögubbar på fönstret",

  description: "Rita små snögubbar på fönstret med fönsterpenna.",

  age: "1-3",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},
{

  title: "Färgglada tånaglar på pappa",

  description: "Måla tånaglarna på pappa med nagellack.",

  age: "4-7",

  place: "sovrum",

  prep: "lagom",

  props: "ja"

},
{

  title: "Selfie-glada Nissen",

  description: "Låt Nissen ta en selfie tillsammans med en sovande förälder på natten. Extrabonus om Nissen skrivit ut bilderna.",

  age: "4-7",

  place: "sovrum",

  prep: "lagom",

  props: "ja"

},

{

  title: "Vattenkaos i badrummet",

  description: "Tejpa igen kranen i handfatet i badrummet.",

  age: "8+",

  place: "badrum",

  prep: "lite",

  props: "ja"

},

{

  title: "Nissen har byggt ett bo",

  description: "Bygg ett litet bo till Nissen av papper och filtar.",

  age: "1-3",

  place: "sovrum",

  prep: "lagom",

  props: "ja"

},

{

  title: "Tomteluva på familjefotot",

  description: "Sätt små tomteluvor av papper på fotografier eller tavlor.",

  age: "4-7",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},
{
  title: "Nissen har tejpat muslasern",

  description: "Sätt en liten bit tejp under datormusen så att den plötsligt slutar fungera.",

  age: "8+",

  place: "sovrum",

  prep: "lite",

  props: "ja"

},

{
  title: "Kodjakten",

  description: "Lämna små ledtrådar med symboler eller rebusar som leder till en överraskning.",

  age: "8+",

  place: "vardagsrum",

  prep: "mycket",

  props: "ja"

},

{
  title: "Nissen har gjort escape room",

  description: "Spänn garn genom hallen så att barnen måste ta sig igenom utan att nudda det.",

  age: "8+",

  place: "hall",

  prep: "mycket",

  props: "ja"

},

{
  title: "Frysta flingor",

  description: "Lägg flingpaketet i frysen under natten så frukosten blir extra överraskande.",

  age: "8+",

  place: "kök",

  prep: "lite",

  props: "ja"

},

{
  title: "Nissen har bytt tangentbord",

  description: "Byt plats på några tangenter på tangentbordet om det går att göra enkelt.",

  age: "8+",

  place: "sovrum",

  prep: "lagom",

  props: "ja"

},
{

  title: "Mobiljakten",

  description: "Göm mobilen på ett enkelt ställe och lämna en rebus som ledtråd.",

  age: "8+",

  place: "sovrum",

  prep: "lite",

  props: "ja"

},

{

  title: "Nissen har gjort frukostmeny",

  description: "Lägg fram en tokig handskriven meny där dagens frukost serveras som på restaurang.",

  age: "8+",

  place: "kök",

  prep: "lagom",

  props: "ja"

},{

  title: "Nissen har busat i kylskåpet",

  description: "Sätt upp små lappar på maten med roliga namn som 'drakmjölk' eller 'snögubbesås'.",

  age: "4-7",

  place: "kök",

  prep: "lagom",

  props: "ja"

},

{
  title: "Mystiskt kodmeddelande",

  description: "Lämna ett brev där vissa bokstäver saknas eller ersatts med symboler.",

  age: "8+",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},
{

  title: "Nissen har byggt en skidbacke",

  description: "Bygg en liten skidbacke av böcker och låt Nisse åka ner på en sked eller leksak.",

  age: "4-7",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},

{

  title: "Soffan har fått pyjamas",

  description: "Sätt barnens pyjamasar på soffkuddarna som om soffan klätt ut sig.",

  age: "4-7",

  place: "vardagsrum",

  prep: "ingen",

  props: "nej"

},

{

  title: "Nissen har bytt plats på ALLT",

  description: "Flytta runt några små saker i köket så att allt står lite tokigt.",

  age: "4-7",

  place: "kök",

  prep: "ingen",

  props: "nej"

},


{

  title: "Julgranen har exploderat",

  description: "Lägg julkulor, glitter och pynt runt granen som om Nisse tappat allt.",

  age: "4-7",

  place: "julgranen",

  prep: "lagom",

  props: "ja"

},


{
  title: "Nissen har gjort popcorn-spår",

  description: "Lägg ett spår av popcorn genom huset som leder till Nissen.",

  age: "8+",

  place: "hall",

  prep: "lite",

  props: "ja"

},

{
  title: "Julgranen har blivit en gamer",

  description: "Häng hörlurar, datormus eller spelkontroll i granen.",

  age: "8+",

  place: "julgranen",

  prep: "ingen",

  props: "nej"

},

{
  title: "Nissen har låst toaletten",

  description: "Sätt ett garn kors och tvärs framför badrumsdörren som en laserbana.",

  age: "8+",

  place: "badrum",

  prep: "lagom",

  props: "ja"

},
{
  title: "Godis på inköpslistan",
  description: "Skriv en inköpslista från Nisse där allt på listan är godis, kakor och juliga godsaker.",
  age: "4-7",
  place: "kök",
  prep: "lite",
  props: "ja"
},

{
  title: "Smileys på clementinerna",
  description: "Rita glada smileys, tomteluvor eller små ansikten på clementinerna.",
  age: "1-3",
  place: "kök",
  prep: "ingen",
  props: "nej"
},

{
  title: "Nisse fast i kakburken",
  description: "Placera Nisse med överkroppen ner i kakburken, som om han fastnat när han försökte ta en kaka.",
  age: "4-7",
  place: "kök",
  prep: "lite",
  props: "ja"
},

{
  title: "Ketchupkonst på skärbrädan",
  description: "Rita en enkel figur, smiley eller hälsning på skärbrädan med ketchup.",
  age: "4-7",
  place: "kök",
  prep: "lite",
  props: "ja"
},

{
  title: "Godisägg i stekpannan",
  description: "Lägg små godisägg i en kall stekpanna som om Nisse försökt steka frukost.",
  age: "4-7",
  place: "kök",
  prep: "lite",
  props: "ja"
},

{
  title: "Magisk mjölk",
  description: "Droppa lite hushållsfärg i mjölken så att frukosten får en tokig färg.",
  age: "4-7",
  place: "kök",
  prep: "lite",
  props: "ja"
},

{
  title: "Figurer på bananerna",
  description: "Rita smileys, Minions-inspirerade figurer eller roliga ansikten på bananerna.",
  age: "4-7",
  place: "kök",
  prep: "ingen",
  props: "nej"
},

{
  title: "Nisse har strukit clementiner",
  description: "Klipp ut små orangea cirklar av papper och lägg dem under ett kallt strykjärn bredvid clementinerna.",
  age: "4-7",
  place: "kök",
  prep: "lagom",
  props: "ja"
},

{
  title: "Non Stop i mjölet",
  description: "Lägg några Non Stop eller annat färgglatt godis i mjölet inför bakdagen.",
  age: "4-7",
  place: "kök",
  prep: "lite",
  props: "ja"
},

{
  title: "Nisse i besticklådan",
  description: "Göm Nisse i besticklådan så att barnen hittar honom när det är dags för frukost.",
  age: "4-7",
  place: "kök",
  prep: "ingen",
  props: "nej"
},

{
  title: "God jul på köksbänken",
  description: "Stava God jul på köksbänken med Non Stop, russin, flingor eller annat litet ätbart.",
  age: "4-7",
  place: "kök",
  prep: "lagom",
  props: "ja"
},
{
  title: "Nissen har kissat i glaset",
  description: "Ställ Nisse över ett glas med mjölk och lite gul saft, som om han råkat göra ett riktigt tokigt bus.",
  age: "4-7",
  place: "badrum",
  prep: "lite",
  props: "ja"
},
{

  title: "Frukost under bordet",

  description: "Busnissen har dukat upp frukosten under köksbordet och tycker att alla ska äta på golvet idag.",

  age: "4-7",

  place: "kök",

  prep: "lagom",

  props: "ja"

},

{

  title: "Robotdammsugaren blev en ren",

  description: "Dekorera robotdammsugaren med ögon, horn och röd nos så att den ser ut som Rudolf.",

  age: "4-7",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},

{

  title: "Nissen har barrikaderat sig",

  description: "Placera Nisse under en stor skål eller i en glasburk med en lapp där det står: 'Pappa/mamma/husdjuret har pruttat – jag kommer inte ut förrän lukten är borta!'",

  age: "8+",

  place: "vardagsrum",

  prep: "lite",

  props: "ja"

},

{

  title: "Hopphage i vardagsrummet",

  description: "Gör en hopphage på golvet med tejp och låt Nisse utmana barnen att hoppa hela vägen.",

  age: "4-7",

  place: "vardagsrum",

  prep: "lagom",

  props: "ja"

},

{

  title: "Nissen hade ont i magen",

  description: "Kleta lite Nutella i handfatet och låt Nisse se väldigt skyldig ut bredvid.",

  age: "4-7",

  place: "badrum",

  prep: "lite",

  props: "ja"

},
{
  title: "Nisse fiskar i handfatet",
  description: "Lägg godisfiskar eller fiskformade kex i handfatet och låt Nisse sitta på kanten med ett litet snöre som fiskespö.",
  age: "4-7",
  place: "badrum",
  prep: "lagom",
  props: "ja"
},

{
  title: "God jul på toapappret",
  description: "Rulla ut lite toalettpapper och skriv God jul eller en liten hälsning från Nisse på pappret.",
  age: "4-7",
  place: "badrum",
  prep: "lite",
  props: "ja"
},

{
  title: "Tandkrämen blev mjukost",
  description: "Byt ut tandkrämstuben mot en tub mjukost eller chokladpålägg och låt Nisse se skyldig ut bredvid.",
  age: "8+",
  place: "badrum",
  prep: "lite",
  props: "ja"
},

{
  title: "Tandborstarna i kylskåpet",
  description: "Göm barnens tandborstar i kylskåpet och låt Nisse lämna en liten ledtråd i badrummet.",
  age: "4-7",
  place: "badrum",
  prep: "ingen",
  props: "nej"
},

{
  title: "Snögubbe av toarullar",
  description: "Stapla tre toalettrullar på varandra, rita ögon, knappar, mun och näsa och sätt Nisse på toppen.",
  age: "4-7",
  place: "badrum",
  prep: "lagom",
  props: "ja"
},

{
  title: "Nisse åker toarulle",
  description: "Placera Nisse inuti en toarulle längst ner vid trappan eller från annan höjd, som om han precis rullat hela vägen ner.",
  age: "4-7",
  place: "hall",
  prep: "lite",
  props: "ja"
},

{
  title: "Nissen har skickat ett uppdrag",

  description: "Lämna en lapp där barnen måste göra ett uppdrag för att få dagens överraskning.",

  age: "8+",

  place: "vardagsrum",

  prep: "lite",

  props: "ja"

},

];
var recentPranks = [];

var recentLimit = 20;

function getRandomItem(array) {

  return array[Math.floor(Math.random() * array.length)];

}

function generatePrank() {

  var age = document.getElementById("prankAge").value;

  var place = document.getElementById("prankPlace").value;

  var prep = document.getElementById("prankPrep").value;

  var props = document.getElementById("prankProps").value;

  var filteredPranks = nissePranks.filter(function(prank) {

    var ageMatch = age === "alla" || prank.age === age;

    var placeMatch = place === "alla" || prank.place === place;

    var prepMatch = prep === "alla" || prank.prep === prep;

    var propsMatch = props === "alla" || prank.props === props;

    var notRecentlyUsed = recentPranks.indexOf(prank.title) === -1;

    return ageMatch && placeMatch && prepMatch && propsMatch && notRecentlyUsed;

  });

  if (filteredPranks.length === 0) {

    recentPranks = [];

    filteredPranks = nissePranks.filter(function(prank) {

      var ageMatch = age === "alla" || prank.age === age;

      var placeMatch = place === "alla" || prank.place === place;

      var prepMatch = prep === "alla" || prank.prep === prep;

      var propsMatch = props === "alla" || prank.props === props;

      return ageMatch && placeMatch && prepMatch && propsMatch;

    });

  }

  if (filteredPranks.length === 0) {

    document.getElementById("prankTitle").textContent = "Oops!";

    document.getElementById("prankDescription").textContent =

      "Nissen hittade inget bus med de valen. Testa att välja Alla på något alternativ.";

  } else {

    var prank = getRandomItem(filteredPranks);

    document.getElementById("prankTitle").textContent = prank.title;

    document.getElementById("prankDescription").textContent = prank.description;

    recentPranks.push(prank.title);

    if (recentPranks.length > recentLimit) {

      recentPranks.shift();

    }

  }

  document.getElementById("prankResult").classList.add("show");

}

document.addEventListener("DOMContentLoaded", function() {

  document.getElementById("generatePrankBtn").addEventListener("click", generatePrank);

  document.getElementById("generateAgainBtn").addEventListener("click", generatePrank);

});